export const UPLOAD_FOLDER_NAME = "upload";
export const FOR_APPROVAL_FOLDER_NAME = "for_approval";
export const RESULTS_FOLDER_NAME = "results";
export const SHARED_BY_EVIDO_FOLDER_NAME = "shared_by_evido";
/** Staff-only folders under `<project>/evido_internal/`. */
export const EVIDO_INTERNAL_FOLDER_NAME = "evido_internal";
export const PROJECT_CONFIGURATION_FOLDER_NAME = "project_configuration";
export const APPROVED_QUALITY_REPORTS_FOLDER_NAME = "approved_quality_reports";
export const MISCELLANEOUS_FOLDER_NAME = "miscellaneous";

/**
 * Product names for the S3 folders behind them. A customer never sees the
 * prefix their files actually live under.
 */
const FOLDER_DISPLAY_NAMES: Record<string, string> = {
  [UPLOAD_FOLDER_NAME]: "Data upload",
  [RESULTS_FOLDER_NAME]: "Processing results",
  [FOR_APPROVAL_FOLDER_NAME]: "Awaiting approval",
  [SHARED_BY_EVIDO_FOLDER_NAME]: "Shared by Evido",
  [EVIDO_INTERNAL_FOLDER_NAME]: "Evido internal",
  [PROJECT_CONFIGURATION_FOLDER_NAME]: "Project configuration",
  [APPROVED_QUALITY_REPORTS_FOLDER_NAME]: "Approved quality reports",
  [MISCELLANEOUS_FOLDER_NAME]: "Miscellaneous",
};

/** What staff see for the root every organization hangs off. */
const ALL_ORGANIZATIONS_DISPLAY_NAME = "All organizations";

/** Index of the project segment in `<root>/<org>/<project>/<folder>/`. */
const PROJECT_SEGMENT_INDEX = 2;

/**
 * Resolve the label for a location prefix such as `organizations/<org>/<project>/results/`.
 */
export function folderDisplayName(
  prefix: string,
  projectPrefixRoot: string,
): string {
  const folderName = prefix.split("/").filter(Boolean).at(-1);
  if (!folderName) {
    return prefix;
  }
  if (folderName === projectPrefixRoot) {
    return ALL_ORGANIZATIONS_DISPLAY_NAME;
  }
  return FOLDER_DISPLAY_NAMES[folderName] ?? folderName;
}

/** The project a prefix such as `organizations/<org>/<project>/upload/` belongs to. */
export function projectOfPrefix(
  prefix: string,
  projectPrefixRoot: string,
): string | undefined {
  const segments = prefix.split("/").filter(Boolean);
  return segments[0] === projectPrefixRoot
    ? segments[PROJECT_SEGMENT_INDEX]
    : undefined;
}

/**
 * Present a project identifier such as `north-harbor-clinic` as `North Harbor Clinic`.
 */
export function projectDisplayName(projectIdentifier: string): string {
  return projectIdentifier
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
